import { render } from "./HomeBlock.vue?vue&type=template&id=17e39f73&scoped=true"
import script from "./HomeBlock.vue?vue&type=script&lang=js"
export * from "./HomeBlock.vue?vue&type=script&lang=js"

import "./HomeBlock.vue?vue&type=style&index=0&id=17e39f73&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-17e39f73"

export default script